"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const dist_1 = require("../../../fs/dist");
const setStatus_1 = require("../../../app/dist/setStatus");
exports.toolDef = {
    name: 'loom_set_status',
    description: 'Set a document\'s lifecycle status (e.g. draft → active → done) — the single status verb for plain docs (idea/design/ctx/reference). Guarded: it refuses transitions a dedicated tool owns and names it — a plan → implementing needs loom_start_plan, a plan → done needs loom_close_plan ("done" is earned by completing steps, not set), a req → locked needs loom_finalize_req. No version bump (a status change is lifecycle, not a spec edit). Use this tool to change a doc\'s status — do not edit files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            doc_ulid: { type: 'string', description: 'ULID of the document whose status to set.' },
            status: { type: 'string', description: 'Target status, e.g. "active", "done", "draft".' },
        },
        required: ['doc_ulid', 'status'],
    },
};
async function handle(root, args) {
    const docUlid = args['doc_ulid'];
    const status = args['status'];
    // Resolve stems/typos to the canonical id at the delivery boundary (suggest-on-miss),
    // then hand the resolved id to the use-case.
    const { id: resolvedId } = await (0, dist_1.resolveDocIdOrThrow)(root, docUlid);
    const result = await (0, setStatus_1.setStatus)({ docUlid: resolvedId, status }, {
        loadDoc: dist_1.loadDoc,
        saveDoc: dist_1.saveDoc,
        getActiveLoomRoot: () => (0, dist_1.getActiveLoomRoot)(root),
        findDocumentById: dist_1.findDocumentById,
    });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
